/**
 * For when you need to reference the names outside this file
 */
export const ROUTER: {
	LOGIN: string
	SIGNUP: string
	TEAM_SIGNUP: string
	EMAIL_VERIFICATION: string
	SESSIONS: string
	SETUP_SESSION: string
	ANOTHER_SESSION: string
	SETUP_ANOTHER_SESSION: string
	LAUNCH: string
	APP_METRICS_REPORT: string
	USER_USAGE_REPORT: string
	COMPANY_USAGE_REPORT: string
	COMPANY_DASHBOARD: string
	TEAM_DASHBOARD: string
	TEAM_MEMBER_DASHBOARD: string
	MEMBERS_DIRECTORY: string
	RUNNITS: string
	RUNNITS_APP: string
	RUNNITS_HOME: string
	RUNNITS_LIBRARY: string
	RUNNITS_ALL_TOOLS: string
	RUNNITS_BOARD: string
	RUNNITS_SUBSCRIPTIONS: string
	RUNNITS_MODELS: string
	RUNNITS_MODELS_LIST: string
	RUNNITS_TRAIN_MODEL_OPTIONS: string
	RUNNIT_BOARDS_PAGE: string
	RUNNIT_BOARDS_V2_PAGE: string
	RUNNIT_BOARD_TEMPLATES_PAGE: string
	RUNNIT_REMIX: string
	RUNNITS_APP_LIBRARY: string
	HELP_CENTER: string
	RUNNITS_WHATS_NEW: string
	MANAGE_UPDATES: string
	RUNNIT_REROUTE: string
	ADMIN_BULK_EDIT_NODE_DEFS: string
	ADMIN_MANAGE_TOOL_TAGS: string
	ADMIN_MANAGE_KITS: string
	ADMIN_FEATURED_TEMPLATES: string
	ADMIN_BOARDS_V2_ROLLOUT: string
	ADMIN_FEEDBACK: string
	ADMIN_FEEDBACK_CONNECT: string
	RUNNITS_REFERRALS: string
	TEAM_USER_PERMISSIONS: string
	COMPANY_USER_PERMISSIONS: string
	TEAM_ROLES: string
	COMPANY_ROLES: string
	COMPANY_SETTINGS: string
	COMPANY_SETTINGS_SSO_SCIM: string
	PLUGINS: string
	AUTH: string
	AUTH_DEVICES: string
	PLUGIN_ONBOARDING: string
	BOARD: string
	BOARD_STRESS: string
	BOARDS_TOUR: string
} = {
	LOGIN: 'Login',
	SIGNUP: 'Signup',
	TEAM_SIGNUP: 'TeamSignup',
	EMAIL_VERIFICATION: 'EmailVerification',
	SESSIONS: 'Sessions',
	SETUP_SESSION: 'SetupSession',
	ANOTHER_SESSION: 'AnotherSession',
	SETUP_ANOTHER_SESSION: 'SetupAnotherSession',
	LAUNCH: 'Launch',
	APP_METRICS_REPORT: 'AppMetricsReport',
	USER_USAGE_REPORT: 'UserUsageReport',
	COMPANY_USAGE_REPORT: 'CompanyUsageReport',
	COMPANY_DASHBOARD: 'CompanyDashboard',
	TEAM_DASHBOARD: 'TeamDashboard',
	TEAM_MEMBER_DASHBOARD: 'TeamMemberDashboard',
	MEMBERS_DIRECTORY: 'MembersDirectory',
	RUNNITS: 'Runnits',
	RUNNITS_APP: 'RunnitsApp',
	RUNNITS_HOME: 'RunnitsHome',
	RUNNITS_LIBRARY: 'RunnitsLibrary',
	RUNNITS_ALL_TOOLS: 'RunnitsAllTools',
	RUNNITS_BOARD: 'RunnitsBoard',
	RUNNITS_SUBSCRIPTIONS: 'RunnitsSubscriptions',
	RUNNITS_MODELS: 'RunnitsModels',
	RUNNITS_MODELS_LIST: 'RunnitsModelsList',
	RUNNITS_TRAIN_MODEL_OPTIONS: 'RunnitsTrainModelOptions',
	RUNNIT_BOARDS_PAGE: 'RunnitBoardsPage',
	RUNNIT_BOARDS_V2_PAGE: 'RunnitBoardsV2Page',
	RUNNIT_BOARD_TEMPLATES_PAGE: 'RunnitBoardTemplatesPage',
	RUNNIT_REMIX: 'RunnitRemix',
	RUNNITS_APP_LIBRARY: 'RunnitAppLibrary',
	HELP_CENTER: 'HelpCenter',
	RUNNITS_WHATS_NEW: 'RunnitsWhatsNew',
	MANAGE_UPDATES: 'ManageUpdates',
	RUNNIT_REROUTE: 'RunnitReroute',
	ADMIN_BULK_EDIT_NODE_DEFS: 'AdminBulkEditNodeDefs',
	ADMIN_MANAGE_TOOL_TAGS: 'AdminManageToolTags',
	ADMIN_MANAGE_KITS: 'AdminManageKits',
	ADMIN_FEATURED_TEMPLATES: 'AdminFeaturedTemplates',
	ADMIN_BOARDS_V2_ROLLOUT: 'AdminBoardsV2Rollout',
	ADMIN_FEEDBACK: 'AdminFeedback',
	ADMIN_FEEDBACK_CONNECT: 'AdminFeedbackConnect',
	RUNNITS_REFERRALS: 'RunnitsReferrals',
	TEAM_USER_PERMISSIONS: 'TeamUserPermissions',
	COMPANY_USER_PERMISSIONS: 'CompanyUserPermissions',
	TEAM_ROLES: 'TeamRoles',
	COMPANY_ROLES: 'CompanyRoles',
	COMPANY_SETTINGS: 'CompanySettings',
	COMPANY_SETTINGS_SSO_SCIM: 'CompanySettingsSsoScim',
	PLUGINS: 'Plugins',
	AUTH: 'Auth',
	AUTH_DEVICES: 'AuthDevices',
	PLUGIN_ONBOARDING: 'PluginOnboarding',
	BOARD: 'Board',
	BOARD_STRESS: 'BoardStress',
	BOARDS_TOUR: 'BoardsTour',
};
